
import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { FaHome, FaBuilding, FaSearch, FaFolderOpen, FaInfoCircle, FaBars, FaTimes, FaSignOutAlt, FaChevronDown, FaEye, FaPrint, FaUpload } from 'react-icons/fa';

const Sidebar = ({ children, onLogout }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [openDropdown, setOpenDropdown] = useState(null);

  const toggleSidebar = () => setIsOpen(!isOpen);

  const toggleDropdown = (index) => {
    setOpenDropdown(openDropdown === index ? null : index);
  };

  const menuItem = [
    {
      path: "/",
      name: "Matrimonial",
      icon: <FaHome size={28} />,
      submenu: [
        { path: "/view", name: "View", icon: <FaEye size={20} /> },
        { path: "/addnew", name: "Add New", icon: <FaUpload size={20} /> },
        { path: "/prepare", name: "Print Preview", icon: <FaPrint size={20} /> },
      ],
    },
    {
      path: "/real-estate",
      name: "Real Estate",
      icon: <FaBuilding size={28} />,
      submenu: [
        { path: "/real-estate/view", name: "View", icon: <FaEye size={20} /> },
        { path: "/real-estate/addnew", name: "Add New", icon: <FaUpload size={20} /> },
        { path: "/real-estate/prepare", name: "Print Preview", icon: <FaPrint size={20} /> },
      ],
    },
    {
      path: "/wanted",
      name: "Wanted",
      icon: <FaSearch size={28} />,
      submenu: [
        { path: "/wanted/view", name: "View", icon: <FaEye size={20} /> },
        { path: "/wanted/addnew", name: "Add New", icon: <FaUpload size={20} /> },
        { path: "/wanted/prepare", name: "Print Preview", icon: <FaPrint size={20} /> },
      ],
    },
    {
      path: "/others",
      name: "Others",
      icon: <FaFolderOpen size={28} />,
      submenu: [
        { path: "/others/view", name: "View", icon: <FaEye size={20} /> },
        { path: "/others/addnew", name: "Add New", icon: <FaUpload size={20} /> },
        { path: "/others/prepare", name: "Print Preview", icon: <FaPrint size={20} /> },
      ],
    },
    { path: "/about", name: "About", icon: <FaInfoCircle size={28} /> },
  ];

  return (
    <div className="flex">
      {/* Sidebar */}
      <div
        className={`
          bg-gradient-to-b from-blue-700 to-purple-600
          text-white
          h-screen
          p-3
          fixed
          top-0
          left-0
          transition-all
          duration-300
          shadow-xl
          flex
          flex-col
          justify-between
          ${isOpen ? "w-64" : "w-[70px]"}
        `}
      >
        <div>
          {/* Toggle button and heading */}
          <div className="flex items-center gap-2 mb-8 ml-2">
            <button
              onClick={toggleSidebar}
              className="text-white focus:outline-none"
            >
              {isOpen ? <FaTimes size={34} /> : <FaBars size={32} className="py-1 px-2" />}
            </button>
            {isOpen && (
              <h1
                onClick={toggleSidebar}
                className="text-2xl md:text-3xl font-bold ml-2 whitespace-normal cursor-pointer select-none"
              >
                Siasat Classified
              </h1>
            )}
          </div>

          {/* Menu items */}
          {menuItem.map((item, index) => (
            <div key={index}>
              <NavLink
                to={item.path}
                end={!!item.submenu} // Exact match for main menu items with submenus
                className={({ isActive }) =>
                  `flex items-center gap-3 text-2xl py-3 px-2 rounded-lg mb-2 transition-all duration-300
                  ${isActive ? 'bg-white text-blue-700 font-semibold shadow' : 'hover:bg-white hover:text-blue-700'}`
                }
                onClick={() => item.submenu && toggleDropdown(index)}
              >
                <div className="min-w-[24px]">{item.icon}</div>
                {isOpen && (
                  <div className="flex justify-between w-full items-center">
                    <span className='text-lg'>{item.name}</span>
                    {item.submenu && (
                      <FaChevronDown
                        className={`transition-transform duration-200 ${
                          openDropdown === index ? "rotate-180" : ""
                        }`}
                      />
                    )}
                  </div>
                )}
              </NavLink>
              {isOpen && item.submenu && openDropdown === index && (
                <div className="ml-6">
                  {item.submenu.map((subItem, subIndex) => (
                    <NavLink
                      to={subItem.path}
                      key={subIndex}
                      className={({ isActive }) =>
                        `flex items-center gap-3 text-2xl py-2 px-3 ml-5 rounded-lg mb-1 transition-all duration-300 ${
                          isActive
                            ? "bg-white text-blue-700 font-semibold shadow"
                            : "hover:bg-white hover:text-blue-700"
                        }`
                      }
                    >
                      <div className="min-w-[20px]">{subItem.icon}</div>
                      <span className='text-lg'>{subItem.name}</span>
                    </NavLink>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Logout button at bottom */}
        <div className="mb-2">
          <NavLink
            to="/logout"
            onClick={onLogout}
            className="flex items-center gap-3 text-white px-3 py-2 rounded-lg hover:bg-white hover:text-blue-700"
          >
            <FaSignOutAlt size={28} />
            {isOpen && <span>Logout</span>}
          </NavLink>
        </div>
      </div>

      {/* Main content */}
      <div className={`flex-1 transition-all duration-300 ${isOpen ? "ml-64" : "ml-[70px]"}`}>
        {children}
      </div>
    </div>
  );
};

export default Sidebar;
